import { render, staticRenderFns } from "./m_footer037.vue?vue&type=template&id=7d3a2606&scoped=true&"
import script from "./m_footer037.vue?vue&type=script&lang=js&"
export * from "./m_footer037.vue?vue&type=script&lang=js&"
import style0 from "./m_footer037.vue?vue&type=style&index=0&id=7d3a2606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3a2606",
  null
  
)

export default component.exports